import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', company: '', message: '' });
    setTimeout(() => setStatus(''), 5000);
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - Helvion Solutions</title>
        <meta name="description" content="Contact Helvion Solutions. Email: info@helvionsolutions.com, Phone: +44 7404666615" />
      </Helmet>
      <main className="contact-page">
        <section className="contact-hero">
          <div className="contact-hero-content">
            <h1>Get In Touch</h1>
            <p>Have a project in mind? Let's discuss how we can help transform your business with innovative IT solutions.</p>
          </div>
        </section>
        <section className="section contact-section">
          <div className="contact-container">
            <div className="contact-info">
              <h2>Contact Information</h2>
              <p className="contact-description">Reach out to us through any of the following channels.</p>
              <div className="contact-details">
                <div className="contact-item">
                  <h3>Email</h3>
                  <a href="mailto:info@helvionsolutions.com">info@helvionsolutions.com</a>
                </div>
                <div className="contact-item">
                  <h3>Phone</h3>
                  <a href="tel:+447404666615">+44 7404666615</a>
                </div>
              </div>
            </div>
            <div className="contact-form-container">
              <h2>Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Your full name" />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="+44 123 456 7890" />
                </div>
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} placeholder="Company name" />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows="6" placeholder="Your message..." />
                </div>
                {status && <div className="form-status success">{status}</div>}
                <button type="submit" className="btn btn-primary btn-submit">Send Message</button>
              </form>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Contact;
